// locales/vi.js
export const vi = {
  welcome: 'Chào mừng',
  logout: 'Đăng xuất',
  settings: 'Cài đặt',

  days: ['Chủ nhật', 'Thứ hai', 'Thứ ba', 'Thứ tư', 'Thứ năm', 'Thứ sáu', 'Thứ bảy'],
  today: 'Hôm nay',
  yesterday: 'Hôm qua',

  THEME: {
    DARK: 'Escuro',
    LIGHT: 'Claro',
  },

  PLACEHOLDER: {
    SEARCH_PLACEHOLDER: 'Tìm kiếm...',
    SELECT_OPTION: 'Chọn một tùy chọn...',
    SELECT_STATUS: 'Chọn trạng thái...',
    CHOOSE_STATUS: 'Chọn trạng thái...',
    LOCATION: 'Nhập thành phố, địa chỉ hoặc địa điểm...',
    DESCRIPTION: 'Mô tả về sự cố',
    AI_DESCRIPTION:
      'Mô tả những gì đã xảy ra, ở đâu và khi nào — ví dụ: Có một đám cháy nhỏ trong phòng điện gần đường Balestier, Novena.',
    LOCATION_DESCRIPTION: 'Thông tin chi tiết bổ sung về vị trí',
    VALIDATING: 'Đang xác thực...',
    GENERATING: 'Đang tạo...',
  },

  CHAT_PANEL: {
    SEARCH_PLACEHOLDER: 'Tìm kiếm...',
    NO_MESSAGES_YET: 'Chưa có tin nhắn nào',
    IS_SPEAKING: 'đang nói...',
    ONLINE: 'trực tuyến',
    OFFLINE: 'ngoại tuyến',
    TRANSCRIBING: 'Đang chuyển ngữ...',
    NO_CHAT_FOUND: 'Không tìm thấy cuộc trò chuyện',
    NO_CHAT_SELECTED_TITLE: 'Chưa chọn cuộc trò chuyện',
    NO_CHAT_SELECTED_DESCRIPTION: 'Chọn người dùng hoặc nhóm từ thanh bên để bắt đầu nhắn tin',
    INPUT_PLACEHOLDER_DEFAULT: 'Nhập tin nhắn...',
    INPUT_PLACEHOLDER_WITH_ATTACHMENT: 'Thêm chú thích...',
    IS_TALKING: 'đang nói...',
    PTT_ACTIVE: 'PTT đang hoạt động - Đang nói...',
    PTT_LOCKED: 'PTT đã khóa - Nhấp để mở',
    PTT_SLIDE_HINT: 'Kéo lên để khóa',
    PTT_RELEASE_AND_SEND: 'Nhả & Gửi',
    ATTACHED_FILES_TITLE: 'Tệp đính kèm',
    FAILED_TO_TRANSCRIBE_AUDIO: 'Không thể chuyển ngữ âm thanh',
    NO_CHAT_MESSAGE: 'Không có tin nhắn chat',
    FALLBACK_MESSAGE: 'Để bắt đầu trò chuyện, hãy nhập tin nhắn hoặc sử dụng tính năng PTT/PTV.',
    INCOMING_VIDEO_CALL: 'Cuộc gọi PTV đến...',
    SOMETHING_WENT_WRONG: 'Có gì đó sai',
    ERROR: 'Lỗi:',
    NO_MESSAGES_FOUND_FOR: 'Không tìm thấy tin nhắn cho',
    SYSTEM_MESSAGE: 'Tin nhắn hệ thống',
    GROUP: 'nhóm',
    AUDIO: 'âm thanh',
    VIDEO: 'video',
    FILE: 'tệp',
    ME: 'tôi',
    IMAGE: 'hình ảnh',
    TEXT: 'văn bản',
    CHAT: 'trò chuyện',
    NONE: 'không có',
    PROFILE: 'hồ sơ',
    SEARCH: 'tìm kiếm',
    COMPLETED: 'hoàn thành',
    RESOLVED: 'đã giải quyết',
    USER_EMAIL_DOMAIN: '@widebridgecloud.com',
    UNKNOWN: 'Không xác định',
    THEM: 'họ',
    HAS_ACCEPTED_THE_INCIDENT: 'đã chấp nhận sự cố',
    INCIDENT_HAS_BEEN_UPDATED: 'Sự cố đã được cập nhật',
    INCIDENT_HAS_BEEN_RESOLVED: 'Sự cố đã được giải quyết',
    YOU_HAVE_JOINED_THE_GROUP: 'Bạn đã tham gia nhóm',
  },

  PROFILE_PANEL: {
    MEMBERS_LABEL: 'thành viên',
    GROUP_MEMBERS_TITLE: 'Thành viên nhóm',
    USERNAME_LABEL: 'Tên người dùng',
    EMAIL_LABEL: 'Email',
    MEMBER_FALLBACK_NAME: 'Thành viên',
    MEMBER_FALLBACK_ID: 'Thành viên',
  },

  PTT: {
    AUDIO: {
      FILENAME_PREFIX: 'ptt-audio-',
      FILE_TYPE: 'audio/webm',
      FILE_EXTENSION: '.webm',
    },
    MESSAGES: {
      START_RECORDING: 'Bắt đầu ghi âm PTT cho {{userName}}',
      STOP_RECORDING: 'Âm thanh PTT đã gửi cho {{userName}}',
      NO_AUDIO_DATA: 'Không nhận được dữ liệu âm thanh từ SDK',
      TRANSCRIPTION_SUCCESS: 'Chuyển ngữ âm thanh hoàn tất',
      TRANSCRIPTION_FAILED: 'Chuyển ngữ thất bại, gửi âm thanh mà không có văn bản',
    },
    TRANSCRIPTION: {
      MODEL: 'whisper-1',
      LANGUAGE: 'vi',
      RESPONSE_FORMAT: 'text',
    },
  },

  CHAT_WINDOW: {
    SEARCH_IN: 'Tìm kiếm trong',
    YOUR_PROFILE: 'Hồ sơ của bạn',
    VIEW_PROFILE: 'Xem hồ sơ',
    PIN_CHAT: 'Ghim trò chuyện',
    UNPIN_CHAT: 'Bỏ ghim trò chuyện',
    MUTE_CHAT: 'Tắt thông báo trò chuyện',
    UNMUTE_CHAT: 'Bật thông báo trò chuyện',
  },

  DASHBOARD: {
    INCIDENTS: 'sự cố',
    INCIDENTS_NO_DATA: 'Để tạo sự cố, hãy nhấp vào nút "+ Tạo sự cố"',
    RESPONDERS: 'người phản hồi',
    RESPONDERS_NO_DATA: 'Không tìm thấy người phản hồi.',
    CHAT: 'trò chuyện',
    ALERTS: 'cảnh báo',
    ALERTS_NO_DATA: 'Không có cảnh báo nào được hệ thống tạo ra.',
    UPDATES: 'cập nhật',
    UPDATES_NO_DATA: 'Không có bản cập nhật nào về sự cố hoặc người phản hồi.',
    NEW_MESSAGE_FROM: 'Tin nhắn mới từ',
    INCIDENT_UPDATED_BY: 'Sự cố được cập nhật bởi',
    NEW_INCIDENT_CREATED_BY: 'Sự cố mới được tạo bởi',
    PROFILE: 'hồ sơ',
    SUMMARY: 'tóm tắt',
    GENERATING_SUMMARY: 'đang tạo tóm tắt...',
  },

  INCIDENTS_PANEL: {
    INCIDENT_NAME: 'Tên sự cố',
    INCIDENT_TYPE: 'Loại sự cố',
    ASSIGNEES: 'người được giao',
    SEVERITY: 'mức độ nghiêm trọng',
    STATUS: 'trạng thái',
    STATUS_HISTORY: 'Lịch sử trạng thái',
    SHOW: 'Hiển thị',
    SHOW_LESS: 'Ẩn bớt',
    MORE: 'thêm',
    PTT: 'PTT',
    LOCATION: 'vị trí',
    SEVERITY_CRITICAL: 'nghiêm trọng',
    SEVERITY_HIGH: 'cao',
    SEVERITY_MEDIUM: 'trung bình',
    SEVERITY_LOW: 'thấp',
    SEVERITY_MINIMAL: 'tối thiểu',
    REPORTED_DATE_TIME: 'Ngày và giờ báo cáo',
    REPORTED_NAME: 'Tên người báo cáo',
    DESCRIPTION: 'mô tả',
    RESPONDERS: 'người phản ứng',
    ATTACHMENTS: 'tệp đính kèm',
    LOCATION_DESCRIPTION: 'mô tả vị trí',
    NO_RESPONDERS_ASSIGNED: 'Không có người phản ứng nào được chỉ định cho sự cố này.',
    CREATE_INCIDENT: 'Tạo sự cố',
    EDIT_INCIDENT: 'Chỉnh sửa sự cố',
    SELECT_RESPONDERS: 'Chọn người phản ứng',
    COMPLETE: 'Hoàn thành',
    CANCEL: 'Hủy',
    SAVE: 'Lưu thay đổi',
    NO: 'Không',
    DATA_FOUND: 'Đã tìm thấy dữ liệu',
    NO_OPTIONS: 'Không có tùy chọn khả dụng',
    AI_ASSISTANCE: 'Hỗ trợ AI',
  },

  TAB_KEYS: {
    ALL: 'tất cả',
    UNREAD: 'chưa đọc',
    ACTIVE: 'đang hoạt động',
    CLOSED: 'đã đóng',
    AVAILABLE: 'sẵn sàng',
    OFFLINE: 'ngoại tuyến',
    TAB_VALUE_UNACKNOWLEDGED: 'chưa xác nhận',
    TAB_VALUE_CREATED: 'đã tạo',
    TAB_VALUE_PROGRESS: 'đang xử lý',
    TAB_VALUE_RESOLVED: 'đã giải quyết',
  },

  UPDATES_PANEL: {
    UPDATES: 'Cập nhật',
    MARK_AS_READ: 'Đánh dấu tất cả là đã đọc',
    ALL: 'Tất cả',
    UNREAD: 'Chưa đọc',
    ALL_KEY: 'tất cả',
    UNREAD_KEY: 'chưa đọc',
    NO_NOTIFICATIONS: 'Không có thông báo',
    NO_UNREAD_NOTIFICATIONS: 'Không có thông báo chưa đọc',
    UPDATE_STATUS: 'Cập nhật trạng thái:',

    NEW_INCIDENT_TITLE: 'Sự cố mới',
    UPDATE_TITLE: 'Cập nhật',

    CREATED_AT: 'tạo lúc',

    STATUS_CLOSED: 'Đã đóng',
    STATUS_IN_PROGRESS: 'Đang xử lý',

    STATUS_CHANGE: 'Trạng thái',
    SEVERITY_CHANGE: 'Mức độ nghiêm trọng',
    TYPE_CHANGE: 'Loại',
    DESCRIPTION_UPDATED: 'Đã cập nhật mô tả',
    RESPONDERS_ADDED: 'đã thêm người phản hồi',
    RESPONDERS_REMOVED: 'đã xóa người phản hồi',
    RESPONDERS_UPDATED: 'Đã cập nhật người phản hồi',
    LOCATION_CHANGED: 'Đã thay đổi vị trí',
    UPDATED_DEFAULT: 'Đã cập nhật',

    UNKNOWN: 'Không xác định',
    JUST_NOW: 'vừa xong',
    MINUTES_AGO: '{{count}} phút trước',
    MINUTES_AGO_plural: '{{count}} phút trước',
    HOURS_AGO: '{{count}} giờ trước',
    HOURS_AGO_plural: '{{count}} giờ trước',
    DAYS_AGO: '{{count}} ngày trước',
    DAYS_AGO_plural: '{{count}} ngày trước',

    DEFAULT_TYPE: 'Sự cố',
    UNKNOWN_LOCATION: 'Vị trí không xác định',
  },

  MAP_VIEW: {
    INCIDENT_TOOLTIP: {
      INCIDENTTYPE: 'Loại sự cố',
      REPORTEDDATE: 'Ngày báo cáo',
      SEVERITY: 'Mức độ nghiêm trọng',
      STATUS: 'Trạng thái',
      RESPONDERS: 'Người phản hồi',
      NO_RESPONDERS: 'Không có người phản hồi',
    },
    INCIDENT_CLUSTER_TOOLTIP: {
      INCIDENTS: 'Sự cố',
      MORE: 'thêm...',
    },
    MAP_FILTER: {
      VIEW_MODE: 'Chế độ xem',
      DEFAULT: 'Mặc định',
      SATELLITE: 'Vệ tinh',
      FILTER_BY: 'Lọc theo',
      ALL: 'tất cả',
      ACTIVE: 'Đang hoạt động',
      COMPLETED: 'Hoàn thành',
      RESPONDERS: 'Người phản hồi',
      AVAILABLE: 'Có sẵn',
    },
  },

  FALLBACK_SCREEN: {
    NO: 'Không',
    DATA_FOUND: 'Dữ liệu tìm thấy',
    CREATE_INCIDENT: 'Tạo sự cố',
    NO_AVAILABLE_RESPONDER_FOUND: 'Không tìm thấy người phản hồi có sẵn',
  },

  PERMISSION_DIALOG: {
    MICROPHONE: {
      TITLE: 'Cần quyền truy cập Microphone',
      DESCRIPTION: 'Ứng dụng này cần quyền truy cập vào microphone của bạn để hoạt động đúng cách.',
      INSTRUCTION: 'Vui lòng cấp quyền truy cập microphone để tiếp tục sử dụng ứng dụng.',
      BUTTON_LABEL: 'Cấp quyền truy cập Microphone',
    },
    CAMERA: {
      TITLE: 'Cần quyền truy cập Camera',
      DESCRIPTION: 'Ứng dụng này cần quyền truy cập vào camera của bạn để hoạt động đúng cách.',
      INSTRUCTION: 'Vui lòng cấp quyền truy cập camera để tiếp tục sử dụng ứng dụng.',
      BUTTON_LABEL: 'Cấp quyền truy cập Camera',
    },
    NOTIFICATIONS: {
      TITLE: 'Cần quyền thông báo',
      DESCRIPTION: 'Ứng dụng này cần quyền để gửi thông báo cho bạn.',
      INSTRUCTION: 'Vui lòng cấp quyền thông báo để tiếp tục sử dụng ứng dụng.',
      BUTTON_LABEL: 'Cấp quyền thông báo',
    },
    GEOLOCATION: {
      TITLE: 'Cần quyền truy cập Vị trí',
      DESCRIPTION: 'Ứng dụng này cần quyền truy cập vào vị trí của bạn để hoạt động đúng cách.',
      INSTRUCTION: 'Vui lòng cấp quyền truy cập vị trí để tiếp tục sử dụng ứng dụng.',
      BUTTON_LABEL: 'Cấp quyền truy cập Vị trí',
    },
    HEADINGS: {
      WHAT_TO_DO: 'Bạn cần làm gì:',
      ADDITIONAL_REQUIRED: 'Yêu cầu quyền bổ sung',
      GENERIC_PERMISSION_TITLE: 'Cần quyền truy cập',
      GENERIC_DESCRIPTION: 'Ứng dụng này yêu cầu quyền truy cập bổ sung để hoạt động đúng cách.',
      GENERIC_INSTRUCTION: 'Vui lòng cấp quyền truy cập cần thiết để tiếp tục.',
    },
    DEFAULT_BUTTON_LABEL: 'Cấp quyền',
  },
  SETTINGS: {
    TITLE: 'Cài đặt',
    SUBTITLE: 'Quản lý tùy chọn ngôn ngữ và dịch của bạn',
    LANGUAGE_DISPLAY: 'Ngôn ngữ hiển thị',
    AUTO_TRANSLATE_TITLE: 'Bật dịch tự động',
    AUTO_TRANSLATE_DESCRIPTION: 'Tự động dịch tin nhắn đến sang ngôn ngữ bạn đã chọn.',
    SAVE_BUTTON: 'Lưu',
    SELECT_PLACEHOLDER: 'Chọn một tùy chọn...',
  },
  SOS_MODAL: {
    TITLE_ALERT_TRIGGERED: 'Cảnh báo SOS đã được kích hoạt',
    LOCATION_LABEL: 'Vị trí',
    INCIDENT_LABEL: 'Sự cố',
    LAST_STATUS_LABEL: 'Trạng thái cuối cùng',
    ASSIST_BUTTON: 'Hỗ trợ',
  },
  HEADER: {
    USERNAME: 'Tên người dùng',
    MODE: 'Chế độ',
    SETTINGS: 'Cài đặt',
    LOG_OUT: 'Đăng xuất',
    TITLE: 'AGIL Field Ops',
  },
  SEVERITY_VALUES: [
    { value: 4, label: 'Nghiêm trọng', dotColor: 'bg-icon-error' },
    { value: 3, label: 'Cao', dotColor: 'bg-chart-2' },
    { value: 2, label: 'Trung bình', dotColor: 'bg-chart-4' },
    { value: 1, label: 'Thấp', dotColor: 'bg-interactive' },
    { value: 0, label: 'Tối thiểu', dotColor: 'bg-icon-muted' },
  ],

  ERRORS: {
    INVALID_CHAT_DATA: 'Dữ liệu trò chuyện không hợp lệ',
    SUMMARY_GENERATION_FAILED: 'Tạo bản tóm tắt thất bại:',
    FAILED_TO_GENERATE_SUMMARY: 'Không thể tạo bản tóm tắt.',
    PLEASE_TRY_AGAIN: 'Vui lòng thử lại.',
    UNKNOWN: 'Không xác định',
    IN_PROGRESS_STATUS_ERROR: 'Phải chỉ định ít nhất một người phản hồi khi trạng thái là "Đang xử lý"',
    RESOLVED_STATUS_ERROR: 'Phải chỉ định ít nhất một người phản hồi trước khi đóng sự cố',
    SELECT_ONE_RESPONDER_ERROR: 'Vui lòng chọn ít nhất một người phản hồi',
    WAIT_BEFORE_SUBMIT_AGAIN: 'Vui lòng đợi trước khi gửi lại',
    INCIDENT_CREATION_SERVICE_UNAVAILABLE: 'Dịch vụ tạo sự cố hiện không khả dụng. Vui lòng thử lại sau.',
    NO_CHANGES_TO_UPDATE: 'Không có thay đổi để cập nhật',
    FAILED_TO_UPDATE_INCIDENT: 'Không thể cập nhật sự cố. Vui lòng kiểm tra kết nối và thử lại.',
    FAILED_TO_CREATE_INCIDENT: 'Không thể tạo sự cố. Vui lòng kiểm tra kết nối và thử lại.',
  },

  INCIDENT_CARD_STATUS_VALUES: [
    { value: 'created', label: 'Đã tạo' },
    { value: 'progress', label: 'Đang xử lý' },
    { value: 'resolved', label: 'Đã giải quyết' },
  ],

  INCIDENT_TYPES: [
    { value: 'Medical', label: 'Y tế' },
    { value: 'Car accident', label: 'Tai nạn ô tô' },
    { value: 'Fire', label: 'Cháy' },
    { value: 'Patrol', label: 'Tuần tra' },
  ],

  CREATE_INCIDENT_STATUS_VALUES: [
    { value: 'open', label: 'Đã tạo' },
    { value: 'in_progress', label: 'Đang xử lý', disabled: false },
  ],

  EDIT_INCIDENT_STATUS_VALUES: [
    { value: 'in_progress', label: 'Đang xử lý' },
    { value: 'resolved', label: 'Đã đóng' },
  ],

  INCIDENT_DETAILS_STATUS_VALUES: [
    { value: 'created', label: 'Đã tạo', disabled: true },
    { value: 'progress', label: 'Đang xử lý', disabled: true },
    { value: 'resolved', label: 'Đã đóng', disabled: true },
  ],

  RESPONSE_STATUS: [
    { value: 'accepted', label: 'Đã chấp nhận' },
    { value: 'rejected', label: 'Từ chối' },
    { value: 'pending', label: 'Đang chờ' },
  ],

  ASSIGNEE_STATUS: [
    { value: 'not_started', label: 'Chưa bắt đầu' },
    { value: 'on_the_way', label: 'Đang di chuyển' },
    { value: 'reach_site', label: 'Đã đến hiện trường' },
    { value: 'enroute', label: 'Đang di chuyển' },
    { value: 'done', label: 'Hoàn thành' },
  ],

  RESPONDER_STATUS: [
    { value: 'Unacknowledged', label: 'Chưa xác nhận' },
    { value: 'Rejected', label: 'Từ chối' },
    { value: 'Arrived at scene', label: 'Đã đến hiện trường' },
    { value: 'On the way', label: 'Đang di chuyển' },
    { value: 'Aborted', label: 'Đã hủy' },
    { value: 'Done', label: 'Hoàn thành' },
  ],

  WEEKDAYS: [
    { value: 'Sun', label: 'CN' },
    { value: 'Mon', label: 'Th 2' },
    { value: 'Tue', label: 'Th 3' },
    { value: 'Wed', label: 'Th 4' },
    { value: 'Thu', label: 'Th 5' },
    { value: 'Fri', label: 'Th 6' },
    { value: 'Sat', label: 'Th 7' },
  ],
};
